import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockComponent } from './lock.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    LockComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
  ],
  exports: [
    LockComponent
  ]
})
export class LockModule { }